import { ApiHttpService } from '../../services'

import router from '../../router'
export const WarehouseLabelModule = {
    namespaced: true,
    state: {
        data: {
            columns: [
                {
                    label: 'Date',
                    field: 'date',
                    sort: 'asc',
                    clickable: false,
                    width: '150'
                },
                {
                    label: 'Label',
                    field: 'label',
                    sort: 'asc',
                }
            ],
            rows: [],
        },
        request: null,
        multipleSelection: [],
        newItemDataObject: [],
        length: 100,
        page: 1,
        total: 1,
        searchTerm: null,
        filters: {},
        loading : false,
        postLoading : false,
        
        form : {},


        initialFormData : {
            date : null,
            type : "license",
            quantity : 1
          },

        getLoading : false,
        getRecordLoading : false,

        formStatus : 'create',

        labelTypes: [
            {label : 'License(Inbound)',value : 'license'},
            {label : 'Outbound',value : 'outbound'},
            {label : 'WH TO SHOWROOM',value : 'showroom-transfer'},
            {label : 'SHOWROOM TO WH',value : 'warehouse-transfer'},
        ],


        getManifestLoading : false,
        
    },
    mutations: {
        addRequest : (state, req) => {
            state.request = {cancel : req.cancel, msg : "loading"}
            console.log("addRequest")
            console.log(state)
        },
        cancelRequest : (state) => {
            state.request.cancel()
            state.loading = true
        },
        clearOldRequest(state, message) {
            state.request.msg = message;
            state.request = null;
        },
        setData(state, payload) {
            state.data = payload
        },
        loadingTrue(state) {
            state.loading = true
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setPostLoadingTrue: (state) => {
            state.postLoading = true
        },
        setPostLoadingFalse: (state) => {
            state.postLoading = false
        },
        setColumns(state, payload) {
            state.data.columns = payload
        },
        setRows(state, payload) {
            state.data.rows = payload
        },
        setPage: (state, payload) => {
            state.page = payload
        },
        setTotal: (state, payload) => {
            state.total = payload
        },
        setLength: (state, payload) => {
            state.length = payload
        },
        setSearchTerm: (state, payload) => {
            state.searchTerm = payload
        },
        setSelection: (state, payload) => {
            state.multipleSelection = payload
        },
        setFilters: (state, payload) => {
            state.filters = payload
        },
        setEmptyData: (state) => {
            state.data.rows = []
        },

        setFormData : (state, payload)=>{

            state.form = payload
        },

        setFormDataItems : (state, payload)=>{
            state.form.items = payload
        },
        setFormRowObject : (state, payload)=>{
            state.form.rowObject = payload
        },

        setEmptyForm : (state) => {
            state.form = JSON.parse(JSON.stringify(state.initialFormData))
        },

        setGetloadingTrue(state) {
            state.getLoading = true
        },
        setGetloadingFalse(state) {
            state.getLoading = false
        },
        setTerm: (state, payload) => {
            state.searchTerm = payload
        },

        setFormStatusCreate : (state) => state.formStatus = 'create',
        setFormStatusUpdate : (state) => state.formStatus = 'update',
        setGetRecordGetLoading : (state,payload) => state.getRecordLoading = payload,
        setGetManifestLoadingTrue : (state) => state.getManifestLoading = true,
        setGetManifestLoadingFalse : (state) => state.getManifestLoading = false,
    },
    actions : {
        resetData({dispatch}, endpoint){

        
            return new Promise((resolve, reject) => { 
                dispatch('asyncGetData', endpoint).then((res) => {

                    console.log("reset data")
                    console.log(res)
                    resolve(res)
                }).catch(error => {

                    console.log("reset error")
                    console.log(error)
                    reject(error)
                })
        });
        },
        async asyncGetData({ state, commit},endpoint) {
           
            const { length, page, filters, searchTerm } = state
            // alert(loading)
            return await new Promise((resolve, reject) => {
            
                    commit('setLoading', true)
                    commit('setRows', [])
                    commit('setFormStatusUpdate')
                    const params = { length: length, page: page, term: searchTerm, filters: filters, view : router.app._route.name }

                    const configParams = {
                        req : "WarehouseLabelModule/req",
                        loadingTrue : "WarehouseLabelModule/loadingTrue",
                        addRequest : "WarehouseLabelModule/addRequest",
                        cancelRequest : "WarehouseLabelModule/cancelRequest",
                        clearOldRequest : "WarehouseLabelModule/clearOldRequest"
                    }

                    ApiHttpService.get(endpoint, params, configParams).then((response) => {
                        commit('setRows', response.data.data)
                        commit('setPage',response.data.current_page)
                        commit('setTotal',response.data.total)
                        commit('setLoading', false)
                        resolve(response.data.data)
                    }).catch(error => {
                        commit('setLoading', false)
                        reject(error)
                    })
                
            })
        },


        async getManifest({ state, commit }, payload) {
            return await new Promise((resolve, reject) => {
                const getLoading = state.getManifestLoading;
                if (!getLoading) {
                    commit('setGetManifestLoadingTrue')
                    const parsePayload = JSON.parse(JSON.stringify(payload))
                    const configParams = {
                        req : "WarehouseLabelModule/req",
                        loadingTrue : "WarehouseLabelModule/setGetManifestLoadingTrue",
                        addRequest : "WarehouseLabelModule/addRequest",
                        cancelRequest : "WarehouseLabelModule/cancelRequest",
                        clearOldRequest : "WarehouseLabelModule/clearOldRequest"
                    }
                    ApiHttpService.get('warehouse-labels/manifest',parsePayload,configParams).then((response) => {
                        commit('setGetManifestLoadingFalse')
                        commit('setFormData',response.data)
                        resolve(response.data)
                    }).catch((error) => {
                        commit('setGetManifestLoadingFalse')
                        reject(error)
                    })
                }
                
            })
        },

      
        async storeRecord({ state, commit }, payload) {
            return await new Promise((resolve, reject) => {
                const postLoading = state.postLoading;
                if (!postLoading) {
                    commit('setPostLoadingTrue')
                    const parsePayload = JSON.parse(JSON.stringify(payload))
                    const configParams = {
                        req : "WarehouseLabelModule/req",
                        loadingTrue : "WarehouseLabelModule/setPostLoadingTrue",
                        addRequest : "WarehouseLabelModule/addRequest",
                        cancelRequest : "WarehouseLabelModule/cancelRequest",
                        clearOldRequest : "WarehouseLabelModule/clearOldRequest"
                    }
                    ApiHttpService.post('warehouse-labels',parsePayload,configParams).then((response) => {
                        commit('setPostLoadingFalse')
                        commit('setFormData',response.data)
                        resolve(response.data)
                    }).catch((error) => {
                        commit('setPostLoadingFalse')
                        reject(error)
                    })
                }
            })
        },

      
    },
    getters: {
        rows: state => state.data.rows,
        data: state => state.data,
        columns: state => state.data.columns,
        selected : state => state.multipleSelection,
        loading : state => state.loading,
        page: state => state.page,
        total: state => state.total,
        length: state => state.length,
        searchTerm: state => state.searchTerm,
        filters: state => state.filters,
        req: state => state.request,
        form: state => state.form,
        initialFormObject: state => state.initialFormData,
        getLoading: state => state.getLoading,
        formData: state => state.form,
        formStatus: state => state.formStatus,
        postLoading: state => state.postLoading,
        getNewItemDataObject: state => state.newItemDataObject,
        labelTypes : state => state.labelTypes,
    }
}



